export type CustomRange = (number | "*")[]

export const DEFAULT_CUSTOM_RANGE: CustomRange = ["*", "*"]
export const DEFAULT_PRICE_RANGE = "*-*"
export const DEFAULT_RANGE = [0, 50000]
